const prodNavbarTheme = {
  palette: {
    // Maneja el color de la tab selected y su base
    primary: {
      main: '#1976d2',
    },
    selectedRole: {
      main: '#1976d2',
    },
    background: {
      default: '#FFFFFF',
    },
  },
  logo: {
    default: '../../logo_colores_oscuro.png',
    isTraining: false,
  },
}

export default prodNavbarTheme
